import {IUser} from "features/authentication/models/IUser";

export const getUserInterestFormData = (user: IUser | null | undefined) => {
    return {
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        phone: user?.phoneNumber || '',
        message: '',
        postalCode: user?.postalCode || '',
        minNumberOfRooms: 0,
        maxNumberOfRooms: 0,
        terms: !!user,
    }
}
